import { DateField, DateTimeField, getFieldNowValue, TimeField } from '@hb/shared'
import { useEffect, useRef } from 'react'

export const useDefaultToNow = (
  field: DateField | DateTimeField | TimeField,
  value: any,
  onChange: (v: any) => void,
) => {
  const { defaultToNow } = field
  const mounted = useRef(false)
  useEffect(() => {
    if (!mounted.current && !value && defaultToNow) {
      setTimeout(() => {
        onChange(getFieldNowValue(field))
        mounted.current = true
      }, 100)
      mounted.current = true
    }
  }, [value, defaultToNow, onChange, field])
  return value
}
